import * as GLOBAL_STORAGE from "garmin.global-store";
import * as _ from "lodash";
import * as module from "module";

const detectedLocale = module.config().detectedLocale;
const detectedCountry = module.config().detectedCountry;
const primaryAddressCountry = module.config().primaryAddressCountry;

const BUY_GARMIN_USER_PREF = "GarminUserPrefs=";
const BUY_GARMIN_LOCALE_PREF = "GarminLocalePref=";
const BUY_GARMIN_PATH_DOMAIN = "; path=/; domain=.garmin.com;";

export interface Locale {
	readonly locale: string;
	readonly wpcLocale: string;
	readonly wlcLocale: string;
	readonly storeURL: string;
	readonly localeName: string;
	readonly region: string;
	readonly cssClassName: string;
	readonly wpcSupported: boolean;
	readonly showInShortList: boolean;
	readonly store: string;
	readonly countryName: string;
}

const DIGITAL_STORE: Locale = {locale: "en_XS", wpcLocale: "en_US", wlcLocale: "en-US", storeURL: "/en-US/digital", localeName: "Other Countries", region: "Other", cssClassName: null, wpcSupported: true, showInShortList: true, store: "digital", countryName: "All Other Countries"};

const PREFERRED_DEFAULT_STORE = DIGITAL_STORE;

/**
 * The below list of locales is duplicated at https://static.garmincdn.com/apps/fly/locales/fly-locales.json and must be updated when this list is.
 * The CDN file is used by flyGarminAppNavigation and flyGarminApp.
 */
const STORES: Array<Locale> = [
	{locale: "es-AR", wpcLocale: "es_AR", wlcLocale: "es-AR", storeURL: "/es-AR/AR", localeName: "Argentina", region: "Americas", cssClassName: "es-AR", wpcSupported: true, showInShortList: true, store: "AR", countryName: "Argentina"},
	{locale: "pt-BR", wpcLocale: "pt_BR", wlcLocale: "pt-BR", storeURL: "/pt-BR/BR", localeName: "Brasil", region: "Americas", cssClassName: "pt-BR", wpcSupported: true, showInShortList: true, store: "BR", countryName: "Brazil"},
	{locale: "en-CA", wpcLocale: "en_CA", wlcLocale: "en-CA", storeURL: "/en-CA/CA", localeName: "Canada (English)", region: "Americas", cssClassName: "en-CA", wpcSupported: true, showInShortList: true, store: "CA", countryName: "Canada"},
	{locale: "es-CL", wpcLocale: "es_CL", wlcLocale: "es-CL", storeURL: "/es-CL/CL", localeName: "Chile", region: "Americas", cssClassName: "es-CL", wpcSupported: true, showInShortList: true, store: "CL", countryName: "Chile"},
	{locale: "es-MX", wpcLocale: "es_MX", wlcLocale: "es-MX", storeURL: "/es-MX/MX", localeName: "México", region: "Americas", cssClassName: "es-MX", wpcSupported: true, showInShortList: true, store: "MX", countryName: "Mexico"},
	{locale: "en-US", wpcLocale: "en_US", wlcLocale: "en-US", storeURL: "/en-US/US", localeName: "United States", region: "Americas", cssClassName: "en-US", wpcSupported: true, showInShortList: true, store: "US", countryName: "United States"},
	{locale: "en-AU", wpcLocale: "en_AU", wlcLocale: "en-AU", storeURL: "/en-AU/AU", localeName: "Australia", region: "Asia Pacific", cssClassName: "en-AU", wpcSupported: true, showInShortList: true, store: "AU", countryName: "Australia"},
	{locale: "zh-CN", wpcLocale: "zh_CN", wlcLocale: "zh-CN", storeURL: "http://shop.yourlbs1.cn/webstore", localeName: "中国 - 中文", region: "Asia Pacific", cssClassName: "zh-CN", wpcSupported: true, showInShortList: true, store: null, countryName: "China"},
	{locale: "en-NZ", wpcLocale: "en_NZ", wlcLocale: "en-NZ", storeURL: "/en-NZ/NZ", localeName: "New Zealand", region: "Asia Pacific", cssClassName: "en-NZ", wpcSupported: true, showInShortList: true, store: "NZ", countryName: "New Zealand"},
	{locale: "zh-TW", wpcLocale: "zh_TW", wlcLocale: "zh-TW", storeURL: "https://my.garmin.com.tw/store", localeName: "台灣 - 中文", region: "Asia Pacific", cssClassName: "zh-TW", wpcSupported: true, showInShortList: true, store: null, countryName: "Taiwan"},
	{locale: "pl-PL", wpcLocale: "pl_PL", wlcLocale: "pl-PL", storeURL: "/pl-PL/PL", localeName: "Polska", region: "Eastern Europe", cssClassName: "pl-PL", wpcSupported: true, showInShortList: true, store: "PL", countryName: "Poland"},
	{locale: "hr-HR", wpcLocale: "hr_HR", wlcLocale: "hr-HR", storeURL: "/hr-HR/HR", localeName: "Croatia", region: "Eastern Europe", cssClassName: "hr", wpcSupported: true, showInShortList: true, store: "HR", countryName: "Croatia"},
	{locale: "en-MT", wpcLocale: "en_US", wlcLocale: "en-US", storeURL: "/en-MT/easterneurope", localeName: "Malta", region: "Eastern Europe", cssClassName: "mt", wpcSupported: true, showInShortList: false, store: "easterneurope", countryName: "Malta"},
	{locale: "sl-SI", wpcLocale: "sl_SI", wlcLocale: "sl-SI", storeURL: "/sl-SI/SI", localeName: "Slovenia", region: "Eastern Europe", cssClassName: "sl-SI", wpcSupported: true, showInShortList: true, store: "SI", countryName: "Slovenia"},
	{locale: "en-AE", wpcLocale: "en_US", wlcLocale: "en-US", storeURL: "/en-AE/mena", localeName: "United Arab Emirates", region: "Middle East", cssClassName: "ae", wpcSupported: true, showInShortList: false, store: "mena", countryName: "United Arab Emirates"},
	{locale: "en-ZA", wpcLocale: "en_ZA", wlcLocale: "en-ZA", storeURL: "/en-ZA/ZA", localeName: "South Africa", region: "Southern Africa", cssClassName: "en-ZA", wpcSupported: true, showInShortList: true, store: "ZA", countryName: "South Africa"},
	{locale: "fr-BE", wpcLocale: "fr_BE", wlcLocale: "fr-BE", storeURL: "/fr-BE/BE", localeName: "Belgique (Français)", region: "Western Europe", cssClassName: "fr-BE", wpcSupported: true, showInShortList: true, store: "BE", countryName: "Belgium"},
	{locale: "nl-BE", wpcLocale: "nl_BE", wlcLocale: "nl-BE", storeURL: "/nl-BE/BE", localeName: "België (Nederlands)", region: "Western Europe", cssClassName: "nl-BE", wpcSupported: true, showInShortList: true, store: "BE", countryName: "Belgium"},
	{locale: "da-DK", wpcLocale: "da_DK", wlcLocale: "da-DK", storeURL: "/da-DK/DK", localeName: "Danmark", region: "Western Europe", cssClassName: "da-DK", wpcSupported: true, showInShortList: true, store: "DK", countryName: "Denmark"},
	{locale: "de-DE", wpcLocale: "de_DE", wlcLocale: "de-DE", storeURL: "/de-DE/DE", localeName: "Deutschland", region: "Western Europe", cssClassName: "de-DE", wpcSupported: true, showInShortList: true, store: "DE", countryName: "Germany"},
	{locale: "es-ES", wpcLocale: "es_ES", wlcLocale: "es-ES", storeURL: "/es-ES/ES", localeName: "España", region: "Western Europe", cssClassName: "es-ES", wpcSupported: true, showInShortList: true, store: "ES", countryName: "Spain"},
	{locale: "fr-FR", wpcLocale: "fr_FR", wlcLocale: "fr-FR", storeURL: "/fr-FR/FR", localeName: "France", region: "Western Europe", cssClassName: "fr-FR", wpcSupported: true, showInShortList: true, store: "FR", countryName: "France"},
	{locale: "it-IT", wpcLocale: "it_IT", wlcLocale: "it-IT", storeURL: "/it-IT/IT", localeName: "Italia", region: "Western Europe", cssClassName: "it-IT", wpcSupported: true, showInShortList: true, store: "IT", countryName: "Italy"},
	{locale: "en-IE", wpcLocale: "en_IE", wlcLocale: "en-IE", storeURL: "/en-IE/GB", localeName: "Ireland", region: "Western Europe", cssClassName: "en-IE", wpcSupported: true, showInShortList: true, store: "GB", countryName: "Ireland"},
	{locale: "nl-NL", wpcLocale: "nl_NL", wlcLocale: "nl-NL", storeURL: "/nl-NL/NL", localeName: "Nederland", region: "Western Europe", cssClassName: "nl-NL", wpcSupported: true, showInShortList: true, store: "NL", countryName: "Netherlands"},
	{locale: "nb-NO", wpcLocale: "nb_NO", wlcLocale: "nb-NO", storeURL: "/nb-NO/NO", localeName: "Norway", region: "Western Europe", cssClassName: "nb-NO", wpcSupported: true, showInShortList: true, store: "NO", countryName: "Norway"},
	{locale: "de-AT", wpcLocale: "de_AT", wlcLocale: "de-AT", storeURL: "/de-AT/AT", localeName: "Österreich", region: "Western Europe", cssClassName: "de-AT", wpcSupported: true, showInShortList: true, store: "AT", countryName: "Austria"},
	{locale: "pt-PT", wpcLocale: "pt_PT", wlcLocale: "pt-PT", storeURL: "/pt-PT/ES", localeName: "Portugal", region: "Western Europe", cssClassName: "pt-PT", wpcSupported: true, showInShortList: true, store: "ES", countryName: "Portugal"},
	{locale: "de-CH", wpcLocale: "de_CH", wlcLocale: "de-CH", storeURL: "/de-CH/CH", localeName: "Schweiz (Deutsch)", region: "Western Europe", cssClassName: "ch", wpcSupported: true, showInShortList: true, store: "CH", countryName: "Switzerland"},
	{locale: "fr-CH", wpcLocale: "fr_CH", wlcLocale: "fr-CH", storeURL: "/fr-CH/CH", localeName: "Suisse (Français)", region: "Western Europe", cssClassName: "ch", wpcSupported: true, showInShortList: true, store: "CH", countryName: "Switzerland"},
	{locale: "fi-FI", wpcLocale: "fi_FI", wlcLocale: "fi-FI", storeURL: "/fi-FI/FI", localeName: "Suomi", region: "Western Europe", cssClassName: "fi-FI", wpcSupported: true, showInShortList: true, store: "FI", countryName: "Finland"},
	{locale: "sv-SE", wpcLocale: "sv_SE", wlcLocale: "sv-SE", storeURL: "/sv-SE/SE", localeName: "Sverige", region: "Western Europe", cssClassName: "sv-SE", wpcSupported: true, showInShortList: true, store: "SE", countryName: "Sweden"},
	{locale: "en-GB", wpcLocale: "en_GB", wlcLocale: "en-GB", storeURL: "/en-GB/GB", localeName: "United Kingdom", region: "Western Europe", cssClassName: "en-GB", wpcSupported: true, showInShortList: true, store: "GB", countryName: "United Kingdom"},
];

function _searchForLocaleCountry(desiredLocale: string): Locale {
	let splitIndex = desiredLocale.indexOf("-");
	let countryCode = splitIndex !== -1 ? desiredLocale.substring(splitIndex + 1) : desiredLocale;

	let foundLocale = _.find(STORES, function(store) {
		let storeSplitIndex = store.locale.indexOf("-") + 1;
		return countryCode === store.locale.substring(storeSplitIndex);
	});

	return foundLocale ? foundLocale : PREFERRED_DEFAULT_STORE;
}

export function flyLocale(desiredLocale: string): Locale {
	let foundStore = _.find(STORES, {locale: desiredLocale});

	return foundStore ? foundStore : _searchForLocaleCountry(desiredLocale);
}

export function flyLocaleByCountryCode(countryCode: string): Locale {
	let foundStore = _searchForLocaleCountry(countryCode);

	return foundStore ? foundStore : PREFERRED_DEFAULT_STORE;
}

export function localesByRegion(): Array<{region: string, locales: Array<Locale>}> {
	let mappedLocales = _.map(_.groupBy(STORES, "region"), function(locales, region) {
		return {region, locales};
	});

	mappedLocales.push({region: PREFERRED_DEFAULT_STORE.region, locales: [PREFERRED_DEFAULT_STORE]});

	return mappedLocales;
}

export function getSortedLocales(): Array<Locale> {
	return STORES.sort((a, b) => {
		const localeNameA = a.localeName.toUpperCase(); // ignore upper and lowercase
		const localeNameB = b.localeName.toUpperCase(); // ignore upper and lowercase
		if (localeNameA < localeNameB) {
			return -1;
		}
		if (localeNameA > localeNameB) {
			return 1;
		}

		// localeNames must be equal
		return 0;
	});
}

export function getDigitalStoreLocale(): Locale {
	return DIGITAL_STORE;
}


export function getSelectedLocale(): Locale {
	if (GLOBAL_STORAGE.getGlobal("locale"))
		return flyLocale(GLOBAL_STORAGE.getGlobal("locale"));
	else if (detectedLocale && flyLocale(detectedLocale))
		return flyLocale(detectedLocale);
	else if (detectedCountry && flyLocaleByCountryCode(detectedCountry))
		return flyLocaleByCountryCode(detectedCountry);
	else
		return flyLocale("en-US");
}

export function getAutoRenewalLocale(): Locale {
	if (primaryAddressCountry && flyLocaleByCountryCode(primaryAddressCountry))
		return flyLocaleByCountryCode(primaryAddressCountry);
	else
		return getSelectedLocale();
}

export function selectLocale(newLocale: Locale) {
	let cookieLocale = newLocale.locale;
	GLOBAL_STORAGE.setGlobal("locale", cookieLocale);

	document.cookie = BUY_GARMIN_USER_PREF + cookieLocale + BUY_GARMIN_PATH_DOMAIN;
	let cookieLocaleUnder = cookieLocale.replace("-", "_");
	document.cookie = BUY_GARMIN_LOCALE_PREF + cookieLocaleUnder + BUY_GARMIN_PATH_DOMAIN;
}
